// Auto-generated enum from table Pages

export const pageName = {
    accountDetails: 'accountDetails',
    accountEdit: 'accountEdit',
    activityCreate: 'activityCreate',
    activityDetails: 'activityDetails',
    activityEdit: 'activityEdit',
    adminPanelDetails: 'adminPanelDetails',
    adminPanelEdit: 'adminPanelEdit',
    categoryCreate: 'categoryCreate',
    categoryDetails: 'categoryDetails',
    categoryEdit: 'categoryEdit',
    claimActionCreate: 'claimActionCreate',
    claimActionDetails: 'claimActionDetails',
    claimActionEdit: 'claimActionEdit',
    claimCreate: 'claimCreate',
    claimDetails: 'claimDetails',
    claimEdit: 'claimEdit',
    contactCreate: 'contactCreate',
    contactDetails: 'contactDetails',
    contactEdit: 'contactEdit',
    contactPhotoDetails: 'contactPhotoDetails',
    contactPhotoEdit: 'contactPhotoEdit',
    contactTypeCreate: 'contactTypeCreate',
    contactTypeDetails: 'contactTypeDetails',
    contactTypeEdit: 'contactTypeEdit',
    contractors: 'contractors',
    creditTypeCreate: 'creditTypeCreate',
    creditTypeDetails: 'creditTypeDetails',
    creditTypeEdit: 'creditTypeEdit',
    domainCreate: 'domainCreate',
    domainDetails: 'domainDetails',
    domainEdit: 'domainEdit',
    domainPhotoDetails: 'domainPhotoDetails',
    domainPhotoEdit: 'domainPhotoEdit',
    domainUserCreate: 'domainUserCreate',
    domainUserDetails: 'domainUserDetails',
    domainUserDomainPhotoDetails: 'domainUserDomainPhotoDetails',
    domainUserEdit: 'domainUserEdit',
    domainUserProfilePhotoDetails: 'domainUserProfilePhotoDetails',
    emailChange: 'emailChange',
    functionCreate: 'functionCreate',
    functionDetails: 'functionDetails',
    functionEdit: 'functionEdit',
    functionMemberCreate: 'functionMemberCreate',
    functionMemberDetails: 'functionMemberDetails',
    functionMemberEdit: 'functionMemberEdit',
    home: 'home',
    imageDetails: 'imageDetails',
    imageEdit: 'imageEdit',
    invitation: 'invitation',
    login: 'login',
    noticeCreate: 'noticeCreate',
    noticeDetails: 'noticeDetails',
    noticeEdit: 'noticeEdit',
    noticePhotoDetails: 'noticePhotoDetails',
    noticePhotoEdit: 'noticePhotoEdit',
    observationTypeCreate: 'observationTypeCreate',
    observationTypeDetails: 'observationTypeDetails',
    observationTypeEdit: 'observationTypeEdit',
    pageComponentCreate: 'pageComponentCreate',
    pageComponentDetails: 'pageComponentDetails',
    pageComponentEdit: 'pageComponentEdit',
    pageCreate: 'pageCreate',
    pageDetails: 'pageDetails',
    pageEdit: 'pageEdit',
    passwordChange: 'passwordChange',
    projectCreate: 'projectCreate',
    projectDetails: 'projectDetails',
    projectEdit: 'projectEdit',
    projectMemberCreate: 'projectMemberCreate',
    projectMemberDetails: 'projectMemberDetails',
    projectMemberEdit: 'projectMemberEdit',
    projectMemberPhotoDetails: 'projectMemberPhotoDetails',
    projectPhotoDetails: 'projectPhotoDetails',
    projectPhotoEdit: 'projectPhotoEdit',
    roleCreate: 'roleCreate',
    roleDetails: 'roleDetails',
    roleEdit: 'roleEdit',
    settings: 'settings',
    taskCreate: 'taskCreate',
    taskDetails: 'taskDetails',
    taskEdit: 'taskEdit',
    taskPhotoDetails: 'taskPhotoDetails',
    tasks: 'tasks',
    taskTypeCreate: 'taskTypeCreate',
    taskTypeDetails: 'taskTypeDetails',
    taskTypeEdit: 'taskTypeEdit',
    themeCreate: 'themeCreate',
    themeDetails: 'themeDetails',
    themeEdit: 'themeEdit',
    userCreate: 'userCreate',
    userPhotoDetails: 'userPhotoDetails',
    userPhotoEdit: 'userPhotoEdit',
}

export type TPageName = (typeof pageName)[keyof typeof pageName];

